import React, { useState } from "react";
import './FilterMenu.scss';
import ThreeStateSwitch from './ThreeStateSwitch';
import { Button, Grid, IconButton, InputBase, LinearProgress, Modal, Paper } from '@material-ui/core';
import { useDispatch, useSelector } from '../../store';

const FilterMenu = ({ onUpdate, isAdmin, query }) => {
	const dispatch = useDispatch();
	const items = useSelector(state => state.items);
	const selected = items.filter(x => x.selected)
	const [status, setStatus] = useState('V') //visible by default
	const isNsfw = query?.nsfw ? query.nsfw : 0
	const [newNsfw, setNewNsfw] = useState(isNsfw) //nsfw by default, for 
	const [addTag, setAddTag] = useState('')

	const handleDeselectAll = (e) => {
		const newItems = items.map(row => {
			row.selected = false;
			return row
		})
		dispatch({ items: newItems })//setItems(newItems)
	}

	const handleUpdateNsfw = async e => {
		// form the update 
		const updates = items.filter(x => x.selected).map(r => {
			return ({ "publicId": r.publicId, "nsfw": newNsfw })
		})
		await onUpdate(updates)
	}

	const handleUpdateStatus = async e => {
		// form the update 
		const updates = items.filter(x => x.selected).map(r => {
			return ({ "publicId": r.publicId, "status": status })
		})
		await onUpdate(updates)
	}

	const handleAddTag = async e => {
		// can be several tags seprated with, 
		if (addTag) {
			const updates = items.filter(x => x.selected).map(r => {
				const stags = (r.tags.length > 0) ? r.tags + ',' + addTag : addTag;
				const newTags = stags.split(',')
					.map(tag => tag.trim().toLowerCase())
					.filter(a => a !== '')
					.sort((A, B) => A > B ? 1 : A < B ? -1 : 0)
				//removing duplicates	
				const tgs = [...new Set(newTags)].join(',')
				return ({ 
					"publicId": r.publicId, 
					"tags": tgs
				})
			})

			await onUpdate(updates)
		}

	}

	return (
		<div className='FilterMenu'>
			<div className='row'>
				<ThreeStateSwitch
					value={isNsfw}
					onChange={(nsfw) => { dispatch({query:{ ...query, nsfw }}) }}  ></ThreeStateSwitch>
			</div>
			{(isAdmin && selected.length > 0) && <div className="row">
				<label>Set status to </label>
				<select value={status} onChange={(e) => setStatus(e.target.value)}>
					<option value="H">Hidden</option>
					<option value="H">Deleted</option>
					<option value="V">👁‍🗨 Visible</option>
					<option value="P">🙎‍♀️ Public</option>
					<option value="F">⭐Featured</option>
					<option value="N">New</option>

				</select>
				<Button className="my-submit" onClick={handleUpdateStatus}>for {selected.length} items</Button>
			</div>}
			{(isAdmin && selected.length > 0) && <div className="row">
				<label>Set content to </label>
				<select value={newNsfw} onChange={(e) => setNewNsfw(e.target.value)}>
					<option value={0}>Safe</option>
					<option value={1}>Adult</option>
				</select>
				<Button className="my-submit" onClick={handleUpdateNsfw}>for {selected.length} items</Button>
			</div>}

			{(isAdmin && selected.length > 0) && <div className='row'>
				<label>Add tag(s) </label>
				<input value={addTag} onChange={(e) => {setAddTag(e.target.value);e.stopPropagation()}} />
				<Button className="my-submit" onClick={handleAddTag} >to {selected.length} items</Button>
			</div>}

			{(isAdmin && selected.length > 0) && <div className='row'>
				<label>Deselect </label>
				<Button className="my-submit" onClick={(e) => handleDeselectAll()}> all {selected.length} items</Button>
			</div>}
		</div>
	)
}

export default FilterMenu